<template>
  <div class="vx-row mt-10">
    <div class="vx-col w-full">
      <div>
        <button
          class="btn btn-primary btn-size-medium mr-5"
          @click="save"
          v-if="isEditable"
          :disabled="saveConfig.disableSave"
        >
          Save Activity
        </button>
        <router-link
          v-if="login_type === 'student'"
          :to="studentBackUrl"
          class="btn btn-secondary btn-size-medium"
          >Back</router-link
        >
        <router-link v-else :to="teacherBackUrl" class="btn btn-secondary btn-size-medium"
          >Back to Activities</router-link
        >
      </div>
      <!--      <vs-button type="gradient" color="danger" class="float-left mr-3" icon-pack="feather" icon="icon-save" @click="save" v-if="isEditable" :disabled="saveConfig.disableSave">Save Activity</vs-button>-->
      <!--      <router-link :to="studentBackUrl" v-if="login_type === 'student'">-->
      <!--        <vs-button color="warning" type="border"  button="reset">Back</vs-button>-->
      <!--      </router-link>-->
      <!--      <router-link v-else :to="teacherBackUrl">-->
      <!--        <vs-button type="gradient" color="danger" class="mt-10" icon-pack="feather" icon="icon-arrow-left">Back to Activities</vs-button>-->
      <!--      </router-link>-->
      <vs-progress indeterminate color="primary" v-if="saveConfig.showSaveProgress"></vs-progress>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      login_type: localStorage.getItem('login_type'),
    };
  },
  computed: {
    studentBackUrl() {
      if (typeof this.$props.studentBack !== 'undefined') return this.$props.studentBack;
      else return '/student/work-experience/' + this.$route.params.id + '/activities';
    },
    teacherBackUrl() {
      if (typeof this.$props.studentBack !== 'undefined') return this.$props.studentBack;
      else return '/teacher/vje/experience/view/' + this.$route.params.id + '/activities/';
    },
  },
  props: ['isEditable', 'studentBack', 'teacherBack'],
  inject: ['saveConfig'],
  methods: {
    save() {
      this.$emit('save');
    },
  },
};
</script>
